export enum LobbyFilterTableType {
    RingGames = 1,
    SitNGo = 2,
    Tournaments = 4,
    SpinNGo = 16,
}

